import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { SidebarService } from '../services/shared/sidebar.service';
import { HeaderComponent } from '../shared/header/header.component';
import { SidebarComponent } from '../shared/sidebar/sidebar.component';
import { BreadcrumbsComponent } from '../shared/breadcrumbs/breadcrumbs.component';
import { ModalVideoComponent } from '../components/modal-video/modal-video.component';
import { ModalPaywallComponent } from '../components/modal-paywall/modal-paywall.component';
import { ModalPdfComponent } from '../components/modal-pdf/modal-pdf.component';

/**
 * Se declaran los plugins para luego inicializarlos
 */
declare function init_plugins(): void;

/**
 * Componente para cargar las pages
 */
@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styles: [],
  imports: [
    HeaderComponent,
    SidebarComponent,
    BreadcrumbsComponent,
    RouterOutlet,
    ModalVideoComponent,
    ModalPaywallComponent,
    ModalPdfComponent,
  ],
})
export class PagesComponent implements OnInit {
  /** Items of the Menu */
  sidebarElements: any;

  /**
   * @ignore
   */
  constructor(
    public sidebarService: SidebarService,
    public router: Router,
  ) {}

  /**
   * Se inicializan los plugins para cargar bien el preloader
   */
  ngOnInit() {
    const route = this.router.url.substring(0, 18);
    init_plugins();
    this.sidebarElements = this.sidebarService.getSidebarElements();
    if (
      route === '/general-documents' ||
      route === '/classrooms' ||
      route === '/topics' ||
      route === '/training-quizzes' ||
      route.includes('/planning-ai')
    ) {
      this.sidebarElements = this.sidebarService.getMenu();
    }
  }
}
